function chooseLocale(val) {

  let _val = val || navigator.language.split('_')[0];
  switch (_val) {
    case 'en':
      return 'en_US';
    case 'zh':
      return 'zh_CN';
    default:
      return 'en_US';
  }
}

const mapStateToProps = (state, ownProps) => ({
  locale: state.language.language, localeMessage: chooseLocale(state.language.language),
});

export default mapStateToProps;